export enum SourcePriceOptionEnum {
    MOVING_AVERAGE_PRICE = 'MOVING_AVERAGE_PRICE',
    PURCHASE_PRICE = 'PURCHASE_PRICE'
}
